// extracted by mini-css-extract-plugin
module.exports = {"container":"InsightsTextarea_container__1yMVp","textareaElement":"InsightsTextarea_textareaElement__3OhCG","draftContainer":"InsightsTextarea_draftContainer__2ZCom"};